import type { Span } from "../../bridge/binary";
import type { AxObjectType } from "../../bridge/selection";
import { useBinaryReader, useBinaryStringPointer } from "../../bridge/binary";
import { createProxies } from "./proxies";

export interface PageNode {
  packageId: string;
  name: string;
}

export interface OutlineNode {
  objectId: string;
  type: AxObjectType;
  name: string;
  displayName: string;
  depth: number;
  childCount: number;
  parentId: string;
  ancestorIds: string[];
  zIndex: number;
  libraryLayerBehavior: LibraryLayerBehavior;
}

export enum LibraryLayerBehavior {
  Folder = 0,
  Item = 1,
}

export interface OutlineObjectNode {
  objectId: string;
  isLocked: boolean;
  isHidden: boolean;
  isVector?: boolean;
  svgIcon?: string;
  svgIconWidth?: number;
  svgIconHeight?: number;
}

interface DocumentExportsMethods {
  GetSitemap: () => Span<PageNode[] | null>;
  SitemapAddNode: (targetIndex: number) => Promise<string>;
  GetOutline: () => Span<OutlineNode[] | null>;
  GetOutlineObject: (objectId: string) => Span<OutlineObjectNode | null>;
  GetImageExport: () => Promise<string>;
  GetImageExportFilename: () => string;
  GetPdfExport: (mode: string) => Promise<string>;
}

export interface DocumentExports {
  Document: DocumentExportsMethods;
}

const {
  setup,
  getSitemap: getSitemapProxy,
  sitemapAddNode,
  getOutline: getOutlineProxy,
  getOutlineObject: getOutlineObjectProxy,
  getImageExport: getImageExportProxy,
  getImageExportFilename,
  getPdfExport: getPdfExportProxy,
} = createProxies<DocumentExportsMethods>([
  "GetSitemap",
  "SitemapAddNode",
  "GetOutline",
  "GetOutlineObject",
  "GetImageExport",
  "GetImageExportFilename",
  "GetPdfExport",
]);

const getSitemap = useBinaryReader(getSitemapProxy);
const getOutline = useBinaryReader(getOutlineProxy);
const getOutlineObject = useBinaryReader(getOutlineObjectProxy);
const getImageExport = useBinaryStringPointer(getImageExportProxy);
const getPdfExport = useBinaryStringPointer(getPdfExportProxy);
export {
  getImageExport,
  getImageExportFilename,
  getOutline,
  getOutlineObject,
  getPdfExport,
  getSitemap,
  setup,
  sitemapAddNode,
};
